module.exports = __webpack_public_path__ + "0d230b380fa59bed8f7c6f2d8873f598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-got-it.png
// module id = 2019
// module chunks = 4